import { Link } from 'react-router-dom';
import { UserAvatar } from '@/components/ui/Avatar';
import { formatRelativeDate } from '@/lib/utils';
import { ROUTES } from '@/constants';

interface QuotedContentProps {
  post: any;
}

/**
 * Renders a quoted post (or quoted reply) embedded inside a quote post.
 */
export default function QuotedContent({ post }: QuotedContentProps) {
  if (!post) return null;

  return (
    <Link
      to={ROUTES.POST.replace(':id', post.id)}
      className="mt-2 mb-3 block transition-colors hover:opacity-90"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="rounded-xl border border-neutral-200 p-3 dark:border-neutral-700">
        <div className="mb-1.5 flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <UserAvatar src={post.profiles?.avatar_url} size="sm" className="mr-1 shrink-0" />
          <span className="max-w-full truncate text-sm font-semibold">
            {post.profiles?.display_name || post.profiles?.username || 'Unknown'}
          </span>
          <span className="max-w-full truncate text-xs text-neutral-500 dark:text-neutral-400">
            @{post.profiles?.username}
          </span>
          <span className="text-xs text-neutral-400 dark:text-neutral-500">
            · {formatRelativeDate(post.created_at)}
          </span>
        </div>
        <p className="whitespace-pre-wrap break-words text-sm leading-relaxed text-neutral-800 dark:text-neutral-200">
          {post.content}
        </p>
        {post.post_media && post.post_media.length > 0 && (
          <div className="mt-2 grid grid-cols-2 gap-2">
            {post.post_media.map((m: any, i: number) => (
              <img
                key={i}
                src={m.url}
                alt="Quoted media"
                loading="lazy"
                className="aspect-square w-full rounded-lg object-cover"
              />
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}
